import React,{ Component } from "react";
import {  Form, Input, Button,Divider,message,Select} from 'antd';
import BreadcrumbCustomer from "../breadcrumb";
import {dbFields}  from '../../model/device/column';
import { getDeviceByImei,editDevice} from '../../model/device/requests';
import {  getCustomList } from "../../model/customs/requests";
import { route } from "../../routes/routes";





export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};
const Option = Select.Option;

class DeviceEdit extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            customList:[],
            custom_id:"",
            data: {},
        }
    }

    componentDidMount(){
        let imei  = this.props.match.params.id;
        let data = {}
        let customList = []
        let customId = ""
        getDeviceByImei({imei:imei}).then(res=>{
            if(res.data.code === 200){
                 data = res.data.data
                 this.formRef.current.setFieldsValue(data);
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

        getCustomList().then(res=>{
            if(res.data.code === 200){
                customList = res.data.data
                if(customList.length > 0 ){
                    for(let i= 0 ;i<customList.length;i++){
                        if(data.custom_id === customList[i].name){
                            customId = customList[i].id
                            data.custom_id = customList[i].id
                            break
                        }
                    }

                    this.setState({
                        customId:customId,
                        customList:customList
                    })
                }
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })

        this.setState({
            data:data
        })

    }

    handlerSubmit = (e) =>{
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key);
        let custom_id = this.state.custom_id;
        editDevice({imei:imei,cid:custom_id}).then(res=>{
            if(res.data.code === 200){
                message.success("update ok")
                setTimeout(()=>{
                    this.props.history.push(route.search.index)
                },1000)

            }else{
                message.warn(res.data.msg)
            }

        }).catch(err=>{
            message.error(" Edit Failed")
        })


    }

    handlerCustomChange = (item) => {
        let custom_id = item
        this.setState({
            custom_id:custom_id
        })
    }

    // handlerCustomChange = (value,option) => {
    //     let custom_id = option.attr
    //     this.setState({
    //         custom_id:custom_id
    //     })
    // }

    render(){
        return(
            <div>
                <BreadcrumbCustomer first='Device' second='Edit' />
                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    onFinish={this.handlerSubmit}
                    initialValues={{
                        imei:this.state.data.imei,
                        custom_id:this.state.data.custom_id
                    }}
                >
                        <Form.Item
                            name= {dbFields.imei.key}
                            label={dbFields.imei.title}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item label={dbFields.custom_id.title} name={dbFields.custom_id.key}>
                        <Select 
                            onChange={this.handlerCustomChange}
                        >
                            {this.state.customList.length > 0  && this.state.customList.map((items) => {
                                 return (<Option  attr={items.name} key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                        </Form.Item>
                        <Form.Item wrapperCol={{span: 12,offset: 6}} >
                            <Button type="primary" htmlType="submit" >Save</Button>
                        </Form.Item>    
                </Form>
            </div>
        )
    }
}

export default DeviceEdit;